import { Platform } from 'react-native';

type WebStorageArea = 'local' | 'session';

function getWebStorage(area: WebStorageArea): Storage | null {
  if (Platform.OS !== 'web' || typeof window === 'undefined') {
    return null;
  }

  try {
    return area === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export function readWebStorage(key: string, area: WebStorageArea = 'local') {
  try {
    return getWebStorage(area)?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeWebStorage(
  key: string,
  value: string,
  area: WebStorageArea = 'local',
) {
  try {
    getWebStorage(area)?.setItem(key, value);
  } catch {
    // Storage can be unavailable in Safari private or restricted contexts.
  }
}

export function removeWebStorage(key: string, area: WebStorageArea = 'local') {
  try {
    getWebStorage(area)?.removeItem(key);
  } catch {
    // Storage can be unavailable in Safari private or restricted contexts.
  }
}
